import { render, staticRenderFns } from "./Anomalies.vue?vue&type=template&id=1c84da6c&scoped=true"
import script from "./Anomalies.vue?vue&type=script&lang=js"
export * from "./Anomalies.vue?vue&type=script&lang=js"
import style0 from "./Anomalies.vue?vue&type=style&index=0&id=1c84da6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c84da6c",
  null
  
)

export default component.exports